import { render, staticRenderFns } from "./LayoutInputImage.vue?vue&type=template&id=2e8e0385&"
import script from "./LayoutInputImage.vue?vue&type=script&lang=js&"
export * from "./LayoutInputImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports